export enum FeatureFlag {
  DEMO_FLAG = 'demo-flag'
}
